'use es6';

import enviro from 'enviro';
import { PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Box } from 'foundations-components/transitional/components/Box';
import { Small } from 'foundations-components/transitional/components/Small';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS } from '../../constants/Tracking.migrated';
import EmbeddedSignup from '../EmbeddedSignup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class HublessError extends PureComponent {
  componentDidMount() {
    const {
      email
    } = this.props;
    UsageTracker.setUpHublessTracker(email).trackHubless('pageView', {
      screen: SCREENS.HUBLESS
    });
  }
  render() {
    const env = enviro.getShort();
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      position: "relative",
      children: [/*#__PURE__*/_jsx(Box, {
        grow: 2,
        inlineSize: "100%",
        children: /*#__PURE__*/_jsx(EmbeddedSignup, {
          env: env
        })
      }), /*#__PURE__*/_jsx(View, {
        insetBlockEnd: "40px",
        maxBlockSize: "400px",
        position: "absolute",
        children: /*#__PURE__*/_jsx(Small, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyErrors.hubless.certsLocation"
          })
        })
      })]
    });
  }
}